var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8GoogleCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "100px",
    height: "100px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ef00ff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,2c-1.64453,0 -3,1.35547 -3,3v30c0,1.64453 1.35547,3 3,3h14v2h-9c-0.03125,0 -0.0625,0 -0.09375,0c-0.26953,0.02734 -0.51953,0.16016 -0.6875,0.375l-5,6c-0.24219,0.30078 -0.28906,0.71094 -0.12109,1.05859c0.16797,0.34766 0.51953,0.56641 0.90234,0.56641h40c0.38281,0 0.73438,-0.21875 0.90234,-0.56641c0.16797,-0.34766 0.12109,-0.75781 -0.12109,-1.05859l-5,-6c-0.19141,-0.23828 -0.47656,-0.375 -0.78125,-0.375h-9v-2h14c1.64453,0 3,-1.35547 3,-3v-30c0,-1.64453 -1.35547,-3 -3,-3zM5,4h40c0.55469,0 1,0.44531 1,1v30c0,0.55469 -0.44531,1 -1,1h-40c-0.55469,0 -1,-0.44531 -1,-1v-30c0,-0.55469 0.44531,-1 1,-1zM6,6v28h38v-28zM8,8h34v24h-34zM19.28125,11.28125l-8,8l-0.6875,0.71875l0.6875,0.71875l8,8l1.4375,-1.4375l-7.28125,-7.28125l7.28125,-7.28125zM30.71875,11.28125l-1.4375,1.4375l7.28125,7.28125l-7.28125,7.28125l1.4375,1.4375l8,-8l0.6875,-0.71875l-0.6875,-0.71875zM21,38h8v4h-8zM10.46875,42h8.53125v2h12v-2h8.53125l3.34375,4h-35.75z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GoogleCode);
export default __webpack_public_path__ + "static/media/icons8-google-code.8a74b80f1de6345bf1c22848546f1701.svg";
export { ForwardRef as ReactComponent };